import { useForm } from "react-hook-form";

export function Form(props) {
  const { schema, options, onSubmit, ...restProps } = props;
  const methods = useForm({
    ...options,
  });

  return (
    <form
      as="form"
      onSubmit={methods.handleSubmit(onSubmit, (formError) =>
        console.log(formError)
      )}
      {...restProps}
    >
      {props.children(methods)}
    </form>
  );
}
